import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import GrayPanel from '../../components/GrayPanel';
import { formDict } from '../rejestracja/Rejestracja';
import { update_user } from '../../actions/user';
import s from './UserInfo.css';
import v from '../eservices/validators';
import ModalAlert from '../eservices/ModalAlert';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';

const errorSpanStyle = {
  color: 'red',
  fontSize: '10px',
};

const userAdressDict = {
  profileID: null,
  AddressType: 'mailAddress',
  AddressCity: null,
  AddressStreet: null,
  AddressNumber: null,
  AddressFlat: null,
  AddressZipCode: null,
  AddressMail: null,
  AddressDistrict: null,
  AddressPrecint: null,
}

class UserInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {
        ...userAdressDict,
        ...this.props.userData,
        url: `/${this.props.userData.pzLogin}/domyslna`
      },
      sectionsMap: new Map(),
      isEditingData: false,
      showModal: false,
      response: null,
      badDataReport: [],
      errors: {},
      errorTitle: '',
      errorText: '',
      showError: false,
      colors: 'normal',
      sourceStyle: layoutColorStyle,
      style: {},
    };

    this.validators = {
      LastName: [v.NotNull],
      FirstName: [v.NotNull],
      AddressCity: [v.NotNull],
      AddressDistrict: [v.NotNull],
      AddressPrecint: [v.NotNull],
      AddressStreet: [],
      username: [v.NotNull],
      Regon: [v.CheckREGON],
      Nip: [v.CheckNIP],
      // AddressStreet: [v.NotNull],
      AddressNumber: [v.NotNull],
      AddressMail: [v.NotNull],
      AddressZipCode: [v.NotNull, v.ExatctLength(6)],
      Email: [v.NotNull, v.CheckEmail],
      PhoneNumber: [v.NotNull, v.isNumber],
    };

    this.state.sectionsMap
    .set({ userData: 'Dane użytkownika' }, ['FirstName', 'LastName', 'FullName', 'Pesel', 'Regon', 'Nip', 'username'])
    .set({ epuapData: 'Dane profilu zaufanego' }, ['pzEmail', 'pzLogin', 'url'])
    // .set({ userDetails: 'Szczegóły użytkownika' }, ['Pesel', 'UserName'])
    .set({ companyData: 'Dane użytkownika' }, ['CompanyName'])
    .set({ companyDetails: 'Szczegóły użytkownika' }, ['Nip', 'Regon'])
    .set({ adress: 'Dane adresowe' }, ['AddressStreet', 'AddressNumber', 'AddressFlat', 'AddressZipCode', 'AddressMail', 'AddressCity', 'AddressDistrict', 'AddressPrecint'])
    .set({ contactData: 'Dane kontaktowe' }, ['Email', 'PhoneNumber']);

    this.createNewUser.bind(this);
    this.updateThisUser.bind(this);
  }

  hidden_fields = ['pzEmail']
  disabled_fields = ['FirstName', 'LastName', 'FullName', 'Pesel','pzLogin','url', 'username']

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };
    }
    if (this.props.userData && !this.props.userData.loginConfirmed){
      this.setState({
        errorText: 'Twoje konto nie posiada informacji niezbędnych do prawidłowego działania usług. Uzupełnij swój profil użytkowika',
        errorTitle: 'Uwaga!',
        showError: true,
        colors,
        sourceStyle,
        style,
      });
      return;
    }
    this.setState({ colors, sourceStyle, style });
  }

  onChange = (e, group) => {
    const name = e.target.name;
    const newGroup = {
      ...this.state[group],
      [name]: e.target.value,
    };

    if (name === 'pzLogin') {
      newGroup['url'] = `/${e.target.value}/domyslna`;
    }
    this.setState(
      {
        [group]: newGroup,
      },
      () => this.validate(group, name),
    );
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['userData'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  userDataEdit = () => {
    this.setState({
      isEditingData: !this.state.isEditingData,
      userData: {
        ...userAdressDict,
        ...this.props.userData,
        url: `/${this.props.userData.pzLogin}/domyslna`
      },
      badDataReport: [],
    });
  }

  validateBeforeModal = () => {
    this.validate(null, null, this.checkFieldErrors);
  }

  checkFieldErrors = () => {
    const hasFieldErrors = this.haseErrors();
    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }
    this.showModalAlert();
  }

  showModalAlert = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  }

  // Function to set a cookie with a new value
  setCookie(name, value, days) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);
    const cookieValue = encodeURIComponent(name) + "=" + encodeURIComponent(value) + "; path=/";
    document.cookie = cookieValue;
  }

  // Function to get the value of a cookie by its name
  getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].split("=");
      if (cookie[0] === name) {
        return decodeURIComponent(cookie[1]);
      }
    }
    return null;
  }

  // Function to change the value of a cookie
  changeCookieValue(cookieName, newValue) {
    const currentValue = this.getCookie(cookieName);
    if (currentValue !== null) {
      // Set the cookie with the new value (you can also update the expiration date if needed)
      this.setCookie(cookieName, newValue, 30); // 30 days expiration, you can adjust as needed
    }
  }

  updateThisUser = () => {
    const data = JSON.stringify(this.state.userData);
    fetch(`${process.env.API_URL}/users/update/${this.state.userData.ID}`,
      {
        method: 'PATCH',
        redirect: 'follow',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data,
      },
    ).then(() => {
      document.cookie = 'userDataUpdated=true; expires=session; path=/';
      window.location.reload();
    });
  }

  createNewUser = () => {
    const data = JSON.stringify(this.state.userData);
    const successMessage = 'Zmiany zostały zapisane. Wymagane jest ponowne zalogowanie.';
    fetch(`${process.env.API_URL}/users/create/`,
      {
        method: 'POST',
        redirect: 'follow',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: data,
      },
    ).then((response) => {
      this.setState({
        response: successMessage,
      });
      window.location.href = '/logout';
    });
  }

  // po kliknieciu przycisku 'Zakmknij' w modalu response
  closeResponseModal = () => {
    this.state.badDataReport.length !== 0 ?
      this.setState({
        response: null,
      })
      :
      this.setState({
        response: null,
        isEditingData: false,
      });
  }

  onHide = () => this.setState({ showError: false });

  renderField = (key, value) => {
    const Labels = formDict.reduce(
      (res, item) => {
        return ({ ...res, [item.shortName]: item.label });
      }, {},
    );
    // zwraca odpowiednio zablokowane inputy dla danych ktorych nie powinnismy edytowac
    let isError = null;
    this.state.badDataReport.map((v, i) => {
      v === key ? isError = s.error : isError = null;
    });

    const isHidden = this.hidden_fields.indexOf(key) > -1;
    const isDisabled = this.disabled_fields.indexOf(key) > -1;

    return !isHidden ? (
      <div key={key}>
        <div className={s.usrKey}>{Labels[key]}</div>
          <div key={key}>
            <input
              onChange={(e) => this.onChange(e, 'userData')}
              type="text"
              name={key}
              disabled={isDisabled || !this.state.isEditingData}
              className={`form-control ${s.usrVal}`}
              value={value ? value : ''}
              style={{
                width: '100%',
                borderColor:
                  Object.keys(this.state.errors).indexOf(key) > -1 &&
                  this.state.errors[key] !== null &&
                  this.state.errors[key].length > 0
                    ? 'red'
                    : '#ccc',
              }}
            />
            {Object.keys(this.state.errors).indexOf(key) > -1 &&
            this.state.errors[key] !== null &&
            this.state.errors[key].length > 0
            ? this.state.errors[key].map((val, index) => (
              <span key={index} style={errorSpanStyle}>
                {val}
              </span>
            ))
          : null}
          </div>
      </div>
    ) : null;
  };
  renderSection = (title, arr) => {
    return (
      <GrayPanel title={Object.values(title)[0]} key={Object.keys(title)[0]}>
        {arr.map(
          item => {
            return this.renderField(item, this.state.userData[item]);
          },
        )
        }
      </GrayPanel>
    );
  };

  // modal z potwierdzeniem lub odrzuceniem zmian
  modalSeTaki = () => {
    return (
      <div className={s.modal}>
        <div className={s.modal__container} style={this.state.style}>
          <div className={s.modal__header}>Czy na pewno chcesz zapisać zmiany?</div>
          <div className={s.usrButtons}>
            <button onClick={this.showModalAlert} className="btn btn-warning">Anuluj</button>
            <button onClick={window.location.pathname === "/registerwk" ? this.createNewUser : this.updateThisUser} className={`btn btn-success ${s.usrButtons__right}`}>Zapisz</button>
          </div>
        </div>
      </div>
    );
  }

  // modal z komunikatem response pod wyslaniu zmian danych uzytkownika
  modalResponse = () => {
    return (
      <div className={s.modal}>
        <div className={s.modal__container} style={this.state.style}>
          <div className={s.modal__header}>{this.state.response}</div>
          <div className={`${s.usrButtons} ${s.center}`}>
            <button onClick={this.closeResponseModal} className="btn btn-success">Zamknij</button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const userData = {
      ...userAdressDict,
      ...this.props.userData,
      url: `/${this.props.userData.pzLogin}/domyslna`
    };
    return (
      <div className={s.usrContainer} style={this.state.style}>
        <div className={s.usrTitle}>Dane:</div>
        <div className={s.usrButtons}>
          <button onClick={this.userDataEdit} className="btn btn-warning">{this.state.isEditingData ? 'Anuluj edycję' : 'Edytuj dane'}</button>
          {JSON.stringify(userData) !== JSON.stringify(this.state.userData) ?
            <button onClick={this.validateBeforeModal} className="btn btn-success">Zapisz zmiany</button>
            :
            null
          }
        </div>
        {
          [...this.state.sectionsMap].filter(
            ([k, v]) => {
              const sectionKeyKey = Object.keys(k)[0];
              return this.state.userData.IsPerson === true ?
                !['companyData', 'companyDetails'].includes(sectionKeyKey) :
                !['userData'].includes(sectionKeyKey);
            },
          ).map(
            ([k, v]) => this.renderSection(k, v),
          )
        }

        <p style={{ marginLeft: "30px;", paddingBottom: "10px;" }}>* - pole obowiązkowe</p>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        {this.state.showModal ? this.modalSeTaki() : null}
        {this.state.response !== null ? this.modalResponse() : null}
      </div>
    );
  }

}

const mapState = (state) => ({});

const mapDispatch = {
  update_user,
};

export default withStyles(s)(connect(mapState, mapDispatch)(UserInfo));




// WEBPACK FOOTER //
// src/routes/userInfo/UserInfo.js